import * as React from 'react';

export const Footer = () => {
    // let today = new Date();
    // let year = today.getFullYear();
    return (
        <div className="footer">
            <LogoExploFooter />
            {/* <h5 className="footer-text">{year}</h5> */}
        </div>
    )
}

export const LogoExploFooter = () => (
    <div className="LogoExplorandesFooter">
        {/* <img src={LogoExplorandesFooter} className="App-logoExplo" alt="logo" /> */}
        <svg
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 1600 800"
            width="120"
            height="60"
            xmlns="http://www.w3.org/2000/svg"
        >
            <polygon points="925.9,59.9 707,373.1 755.5,443 925.9,199.2 1271.1,693.1 869,693.1 550.1,236.9 181.3,764.7 
                373.6,764.7 423.2,693.1 328.6,693.1 550.1,376.2 821.6,764.7 1418.4,764.7 "/>
            <polygon points="580.7,693.1 645.6,600.3 597.1,530.4 444.6,748.6 434,764.7 760.2,764.7 710.6,693.1 " />
            <path d="M1098.1,67.1c17.7,0,32.1,14.4,32.1,32.1s-14.4,32.1-32.1,32.1s-32.1-14.4-32.1-32.1c0,0,0,0,0,0
                C1066.1,81.5,1080.4,67.2,1098.1,67.1 M1098.1,59.9c-21.7,0-39.3,17.6-39.3,39.3s17.6,39.3,39.3,39.3c21.7,0,39.3-17.6,39.3-39.3
                c0,0,0,0,0,0C1137.5,77.5,1119.9,59.9,1098.1,59.9z"/>
            <path d="M1107.1,116.4l-9.1-12.9h-8.1v12.9h-6.5v-37h16.5c8.5,0,13.7,4.5,13.7,11.7c0,6.1-3.6,9.8-8.8,11.2l10,14
                L1107.1,116.4z M1099.3,85.4h-9.4v12.4h9.5c4.6,0,7.6-2.4,7.6-6.2C1107,87.4,1104.1,85.3,1099.3,85.4L1099.3,85.4z"/>
        </svg>
    </div>
);
